import { ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import LeftMenu, { TLeftMenuState } from 'src/components/common/leftMenu/LeftMenu';
import { demoDayRocketCircle, hTractionLogoWithText, StartupScoringVector, FundingIllustration } from 'src/assets/images';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TUserTypes } from 'src/constants/user.constants';
import cx from './sidebarcard.module.scss';
import './navigation.scss';
import { Loader } from '../common';

export type TNavigation = {
  url: string;
  key: string;
  startIcon: ReactNode;
  endIcon?: ReactNode;
  title: ReactNode;
  notificationCount: number;
  state: TLeftMenuState;
  availableToUserType: TUserTypes | 'All';
};

const Navigation = ({ items, handleNavigateToMVP }: { items: TNavigation[], handleNavigateToMVP: any, loading }) => {
  const navigate = useNavigate();
  const { showNavBar } = useAppSelector((store) => store.common);
  const { isAuthorized } = useAppSelector((store) => store.auth);
  const navigateTo = () => {
    if (isAuthorized) {
      navigate('/score');
    } else {
      navigate('/')
    }
  };
  const [loading, setLoading] = useState<boolean>(false)
  const { myCompany } = useAppSelector((store) => store.company);

  function onSubmit() {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1200)
    // handleNavigateToMVP && handleNavigateToMVP()
    if (myCompany?.termsAndConditions) {
      navigate(`/score`);
    } else {
      navigate('/scoring-engine');
    }
  }
  return (
    <div className={classNames('navigation', { 'navigation--is-open': showNavBar })}>
      <div className="navigation__menu">
        <img
          src={hTractionLogoWithText}
          alt="htraction logo"
          className="navigation__menu__htraction-logo"
          onClick={navigateTo}
        />
        <div className="navigation__menu__items">
          {items.map(({ key, title, url, availableToUserType, ...rest }) => {
            return (
              <LeftMenu key={key} url={url} {...rest}>
                {title}
              </LeftMenu>
            );
          })}
          {/* <div className={cx.card}>
            <img src={demoDayRocketCircle} className={cx.image} alt="rocker" />
            <h5 className={cx.heading}>Build your MVP</h5>
            <p className={cx.desc}>Get <strong>15%</strong> off on AppOpen, just
              for htraction users</p>
            {isAuthorized && <button className={cx.button} onClick={onSubmit}>
              {loading ? 'Redirecting! Please wait...' : 'Start Building Now'}
            </button>}
          </div> */}
          {/* {myCompany?.termsAndConditions ? <div className={cx.card}>
            <img src={FundingIllustration} className={cx.image} alt="Startup Funding" />
            <h6 className={cx.heading}>Funding starts here</h6>
            <p className={cx.desc}>Get <b>Scored.</b> Get <b>Matched.</b> Get <b>Funded.</b></p>
            {isAuthorized && <button className={cx.button} onClick={onSubmit}>
              {loading ? 'Redirecting! Please wait...' : 'View Details'}
            </button>}
          </div> : <div className={cx.card}>
            <img src={FundingIllustration} className={cx.image} alt="Startup Funding" />
            <h6 className={cx.heading}>Ready to raise funds?</h6>
            <p className={cx.desc}>Get <b>Scored.</b> Get <b>Matched.</b> Get <b>Funded.</b></p>
            {isAuthorized && <button className={cx.button} onClick={onSubmit}>
              {loading ? 'Redirecting! Please wait...' : 'Apply Now'}
            </button>}
          </div>} */}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
